interface ThreadReplySeparatorProps {
  readonly count: number
}

export function ThreadReplySeparator({ count }: ThreadReplySeparatorProps) {
  const replyText = `${count} ${count <= 1 ? 'reply' : 'replies'}`

  return (
    <div className="flex w-full items-center py-3 px-4 text-xs text-gray-500 shrink-0 select-none">
      <div className="flex-1 h-px bg-gray-200" />
      <span className="mx-3 whitespace-nowrap">{replyText}</span>
      <div className="flex-1 h-px bg-gray-200" />
    </div>
  )
}
